<template>
  <EditorIsland role="banner" class="flex min-h-20 w-full flex-shrink-0 flex-wrap items-center gap-2">
    <NuxtLink
      to="/"
      class="ml-2 mr-4 flex items-center gap-2 pr-4"
      :class="{ 'border-r-2 border-gray-400': breadcrumbs }"
    >
      <img src="/logo.svg" class="h-10 w-10 object-contain" alt="Didab logo" />
      <h1 class="flex gap-2 text-2xl font-bold">
        <span class="text-[#336666]">didab</span><span class="text-[#f0000a]">Editor</span>
      </h1>
    </NuxtLink>

    <ul v-if="breadcrumbs" class="flex flex-wrap gap-1 text-2xl">
      <li v-for="(link, i) in breadcrumbs" :key="link.to" class="flex flex-wrap items-center gap-1">
        <h2 v-if="i === breadcrumbs.length - 1">{{ link.label }}</h2>
        <template v-else>
          <NuxtLink :to="link.to" :class="{ underline: link.to }">
            {{ link.label }}
          </NuxtLink>
          <i-icon-park-outline:arrow-right class="h-6 w-6" />
        </template>
      </li>
    </ul>
    <slot />

    <div class="ml-auto flex flex-wrap gap-2">
      <slot name="end" />
    </div>
  </EditorIsland>
</template>

<script setup lang="ts">
defineProps<{
  breadcrumbs?: { label?: string; to?: string }[];
}>();
</script>
